import { Select as SelectPrimitive } from '@base-ui/react/select';

import { cn } from '@/lib/utils';

import SelectScrollDownButton from './SelectScrollDownButton';
import SelectScrollUpButton from './SelectScrollUpButton';

export type SelectContentProps = SelectPrimitive.Popup.Props &
  Pick<
    SelectPrimitive.Positioner.Props,
    'align' | 'alignOffset' | 'side' | 'sideOffset' | 'alignItemWithTrigger'
  >;

const SelectContent = ({
  className,
  children,
  side = 'bottom',
  sideOffset = 4,
  align = 'center',
  alignOffset = 0,
  alignItemWithTrigger = false,
  ...props
}: SelectContentProps) => {
  return (
    <SelectPrimitive.Portal>
      <SelectPrimitive.Positioner
        side={side}
        sideOffset={sideOffset}
        align={align}
        alignOffset={alignOffset}
        alignItemWithTrigger={alignItemWithTrigger}
        positionMethod="fixed"
        className="isolate z-1101"
      >
        <SelectPrimitive.Popup
          data-slot="select-content"
          data-align-trigger={alignItemWithTrigger}
          className={cn(
            'relative isolate z-1101 max-h-(--available-height) w-(--anchor-width) origin-(--transform-origin)',
            'overflow-y-auto data-[align-trigger=true]:animate-none',
            'border-gray-900 bg-white text-gray-900 duration-100',
            'data-open:animate-in data-closed:animate-out data-closed:fade-out-0 data-open:fade-in-0 data-closed:zoom-out-95 data-open:zoom-in-95',
            'data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[size=right]:slide-in-from-left-2 data-[size=top]:slide-in-from-bottom-2',
            'data-[side=inline-start]:slide-in-from-right-2 data-[side=inline-end]:slide-in-from-left-2',
            'max-h-64 min-w-12 rounded-xs shadow-md ring-1 ring-gray-900/10',
            'data-ending-style:opacity-0 data-starting-style:opacity-0',
            className,
          )}
          {...props}
        >
          <SelectScrollUpButton />
          <SelectPrimitive.List>{children}</SelectPrimitive.List>
          <SelectScrollDownButton />
        </SelectPrimitive.Popup>
      </SelectPrimitive.Positioner>
    </SelectPrimitive.Portal>
  );
};

export default SelectContent;
